(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-luxe-contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var launcher = event.target.closest('[data-bl-chat-launcher]');
    if (!launcher) return;
    var chatHost = document.querySelector('shopify-chat');
    var chatButton = document.querySelector('button[aria-label="Chat"]');
    if (!chatButton && chatHost && chatHost.shadowRoot) {
      chatButton = chatHost.shadowRoot.querySelector('button');
    }
    if (chatButton) chatButton.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["black-luxe-general-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-bl-faq]');

    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const search = root.querySelector('[data-faq-search]');
      const clear = root.querySelector('[data-faq-clear]');
      const status = root.querySelector('[data-faq-status]');
      const suggestions = root.querySelector('[data-faq-suggestions]');
      const topicLinks = Array.from(root.querySelectorAll('[data-faq-jump]'));
      const categories = Array.from(root.querySelectorAll('[data-faq-category]'));
      const items = Array.from(root.querySelectorAll('[data-faq-item]'));
      const empty = root.querySelector('[data-faq-empty]');
      const backTop = root.querySelector('[data-faq-back-top]');
      const normalizer = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const synonymGroups = [
        ['refund', 'return', 'exchange', 'cancel'],
        ['broken', 'cracked', 'damaged', 'wrong item', 'incorrect'],
        ['tracking', 'shipping', 'delivery', 'lost package', 'transit'],
        ['pickup', 'collect', 'ready'],
        ['address', 'apartment', 'unit'],
        ['ingredients', 'wax', 'soy'],
        ['wick', 'tunneling', 'soot', 'burn', 'candle care'],
        ['allergy', 'allergic', 'headache', 'sensitivity', 'strong scent', 'fragrance'],
        ['gift', 'gift card', 'e gift'],
        ['unsubscribe', 'stop emails', 'marketing email']
      ];

      const searchableText = new Map();
      items.forEach((item) => {
        searchableText.set(item, normalizer(`${item.textContent} ${item.dataset.keywords || ''}`));
      });

      const expandedTerms = (query) => {
        const terms = new Set(normalizer(query).split(' ').filter(Boolean));
        synonymGroups.forEach((group) => {
          if (group.some((term) => normalizer(query).includes(normalizer(term)))) {
            group.forEach((term) => normalizer(term).split(' ').forEach((word) => terms.add(word)));
          }
        });
        return Array.from(terms);
      };

      const resetOpenState = () => {
        items.forEach((item) => item.removeAttribute('open'));
      };

      const clearSuggestions = () => {
        suggestions.replaceChildren();
        suggestions.hidden = true;
      };

      const restoreAll = () => {
        status.textContent = '';
        empty.hidden = true;
        clearSuggestions();
        resetOpenState();
        items.forEach((item) => { item.hidden = false; });
        categories.forEach((group) => { group.hidden = false; });
      };

      const applySearch = () => {
        const query = normalizer(search.value);
        clear.hidden = query.length === 0;

        if (query.length < 2) {
          restoreAll();
          return;
        }

        const terms = expandedTerms(query);
        const ranked = items.map((item, index) => {
          const text = searchableText.get(item);
          const question = normalizer(item.querySelector('summary').textContent);
          let score = 0;
          if (question === query) score += 100;
          if (question.includes(query)) score += 40;
          if (text.includes(query)) score += 20;
          terms.forEach((term) => {
            if (question.includes(term)) score += 8;
            else if (text.includes(term)) score += 3;
          });
          return { item, index, score };
        }).filter((result) => result.score > 0)
          .sort((a, b) => b.score - a.score || a.index - b.index)
          .slice(0, 6);

        const visible = new Set(ranked.map((result) => result.item));
        suggestions.replaceChildren();
        ranked.forEach(({ item }) => {
          const suggestion = document.createElement('button');
          const label = document.createElement('span');
          const arrow = document.createElement('span');
          const questionText = item.querySelector('summary span').textContent.trim();
          suggestion.type = 'button';
          suggestion.className = 'bl-faq__suggestion';
          label.textContent = questionText;
          arrow.className = 'bl-faq__suggestion-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = '→';
          suggestion.append(label, arrow);
          suggestion.addEventListener('click', () => {
            search.value = questionText;
            clear.hidden = false;
            items.forEach((faqItem) => { faqItem.hidden = faqItem !== item; });
            categories.forEach((group) => { group.hidden = !group.contains(item); });
            resetOpenState();
            item.setAttribute('open', '');
            clearSuggestions();
            status.textContent = 'Showing 1 matching question.';
            item.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
          suggestions.appendChild(suggestion);
        });
        suggestions.hidden = ranked.length === 0;
        resetOpenState();
        items.forEach((item) => { item.hidden = !visible.has(item); });
        categories.forEach((group) => {
          group.hidden = !Array.from(group.querySelectorAll('[data-faq-item]')).some((item) => !item.hidden);
        });
        empty.hidden = ranked.length !== 0;
        status.textContent = ranked.length === 0
          ? 'No matching questions found.'
          : `${ranked.length} matching ${ranked.length === 1 ? 'question' : 'questions'}.`;

        if (ranked.length === 1 && ranked[0].score >= 40) {
          ranked[0].item.setAttribute('open', '');
        }
      };

      topicLinks.forEach((topicLink) => {
        topicLink.addEventListener('click', (event) => {
          const target = root.querySelector(topicLink.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          search.value = '';
          clear.hidden = true;
          restoreAll();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          window.history.replaceState(null, '', topicLink.getAttribute('href'));
        });
      });

      search.addEventListener('input', applySearch);
      clear.addEventListener('click', () => {
        search.value = '';
        clear.hidden = true;
        restoreAll();
        search.focus();
      });

      const updateBackTop = () => {
        backTop.classList.toggle('is-visible', window.scrollY > 520);
      };

      backTop.addEventListener('click', (event) => {
        event.preventDefault();
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, true);
      window.addEventListener('scroll', updateBackTop, { passive: true });
      updateBackTop();

      root.querySelectorAll('[data-live-chat]').forEach((button) => {
        button.addEventListener('click', () => {
          const chat = document.querySelector('shopify-chat');
          const launcher = chat && chat.shadowRoot ? chat.shadowRoot.querySelector('button') : null;
          if (launcher) launcher.click();
          else {
            const existingLauncher = document.querySelector('[data-shopify-chat], .chat-toggle, [aria-label*="chat" i]');
            if (existingLauncher) existingLauncher.click();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
